export default __webpack_public_path__ + "static/media/send-icon-white.c2aace57.svg";